/**
 * Throw errors to [client-error-log service](https://github.com/optimizely/client-error-log)
 * @module
 */
var _ = require('optimizely-client-fn');

var CustomError = require('core/utils/custom_error').BaseError;
var DateEnv = require('core/env/date');
var di = require('core/di');
var DocumentEnv = require('core/env/document');
var Logger = require('core/utils/logger');
var WindowEnv = require('core/env/window');
var xhr = require('core/utils/xhr');

var ClientMetadata = di.get('stores/client_metadata');
var GlobalStore = di.get('stores/global');

var ERROR_LOG_HOST = __ERROR_LOG_HOST__;
var EXPERIMENTAL_EDGE_SPA = __EXPERIMENTAL_EDGE_SPA__;
var EXPERIMENTAL_TRACKING_ONLY = __EXPERIMENTAL_TRACKING_ONLY__;

/**
 * Log an error payload to ERROR_LOG_HOST
 * @param {Error} error
 * @param {Object} [meta]
 */
exports.handleError = function(error:Error, meta?:any) {
  // TODO:  Reorganize this to separate normal logger from this function
  if (__ERROR_MONITOR__) {
    // Log a custom event with part of the stack trace as the name.
    var name = error.name || 'Error';

    // Message is a required field in the logtier, so set it to something:
    // https://github.com/optimizely/client-error-log/blob/07a23b2d18b9d764079a9e6fcfedc6acf0bc9601/models/src/main/avro/ClientErrorAvro.avsc#L11
    var message = error.message || '';
    var stacktrace = error.stack || null;

    if (error instanceof CustomError) {
      if (message as any instanceof Error) {
        message = (message as any).message;
        stacktrace = (error.message as any).stack;
      } else {
        stacktrace = null;
      }
    }

    var data:any = {
      timestamp: DateEnv.now(),
      clientEngine: getClientEngine(meta),
      clientVersion: ClientMetadata.getClientVersion(),
      accountId: GlobalStore.getAccountId(),
      projectId: GlobalStore.getProjectId(),
      errorClass: name,
      message: message,
      stacktrace: stacktrace
    };

    var metadata = _.map(GlobalStore.getExperimental(), function(value, key) {
      return {
        key: 'exp_' + key,
        value: String(value),
      };
    });

    if (meta) {
      _.forEach(meta, function(value, key) {
        // Skip complex data types
        if (!_.isObject(value)) {
          metadata.push({
            key: key,
            // Coerce value to string
            value: String(value),
          });
        }
      }, []);
    }

    if (!_.isEmpty(metadata)) {
      data.metadata = metadata;
    }

    Logger.error('Logging error', data);

    function sendError() {
      return xhr.request({
        url: ERROR_LOG_HOST + '/log',
        method: 'POST',
        data: data,
        contentType: 'application/json',
      }).then(function(response) {
        Logger.log('Error Monitor / Logged error with response: ', response);
      }, function(xhrResponse) {
        Logger.error('Failed to log error, response was: ', xhrResponse);
      });
    }

    if (DocumentEnv.isLoaded()) {
      sendError();
    } else {
      WindowEnv.addEventListener('load', sendError);
    }
  } else {
    if (meta) {
      Logger.error('Uncaught error:', error, meta);
    } else {
      Logger.error('Uncaught error:', error);
    }
  }
};

/**
 * Returns the client engine for this error log.
 * Note that the edge-* client engine names are only used in our
 * error monitor. Events sent to logx just use "edge" as the client
 * engine.
 *
 * @param {Object} [meta]
 * @returns {string}
 */
function getClientEngine(meta?:any): string {
  if (meta && meta.engine) {
    return meta.engine;
  } else if (EXPERIMENTAL_TRACKING_ONLY) {
    return 'edge-tracking';
  } else if (EXPERIMENTAL_EDGE_SPA) {
    return 'edge-helper';
  }
  return ClientMetadata.getClientName();
}

if (__TEST__) {
  exports.ERROR_LOG_HOST = ERROR_LOG_HOST;

  exports.setEdgeTracking = function(edgeTracking) {
    EXPERIMENTAL_TRACKING_ONLY = edgeTracking;
  };

  exports.setEdgeSpa = function(edgeSpa) {
    EXPERIMENTAL_EDGE_SPA = edgeSpa;
  };
}
